import createIcon from '../../createIcon';

/**
 * @component @name BluetoothDisabled
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMgNS44M0wxNC44OCA3LjcxTDEzLjI4IDkuMzFMMTQuNjkgMTAuNzJMMTcuNzEgNy43TDEyIDJIMTFWNy4wM0wxMyA5LjAzVjUuODNaTTUuNDEgNEw0IDUuNDFMMTAuNTkgMTJMNSAxNy41OUw2LjQxIDE5TDExIDE0LjQxVjIySDEyTDE2LjI5IDE3LjcxTDE4LjU5IDIwTDIwIDE4LjU5TDUuNDEgNFpNMTMgMTguMTdWMTQuNDFMMTQuODggMTYuMjlMMTMgMTguMTdaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BluetoothDisabled = createIcon('BluetoothDisabled', [
  [
    'path',
    {
      d: 'M13 5.83L14.88 7.71L13.28 9.31L14.69 10.72L17.71 7.7L12 2H11V7.03L13 9.03V5.83ZM5.41 4L4 5.41L10.59 12L5 17.59L6.41 19L11 14.41V22H12L16.29 17.71L18.59 20L20 18.59L5.41 4ZM13 18.17V14.41L14.88 16.29L13 18.17Z',
      key: 'bcbiip',
    },
  ],
]);

export default BluetoothDisabled;
